import React, { useState, useEffect } from "react";
import "../../css/Navbar.css";
import { NavLink } from "react-router-dom";

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 120);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className={`navbar-wrapper ${isScrolled ? "navbar-sticky" : ""}`}>
      
      {/* Top Contact Bar */}
      <div className="topmenu background-black">
        <div className="container d-flex justify-content-between py-2">
          <div>
            <i className="fa fa-phone"></i>
            <a href="tel:+919692908506"> +91 9692908506</a>
          </div>
          <div className="social-icons">
            <a href="#"><i className="fa fa-facebook" /></a>
            <a href="#"><i className="fa fa-instagram" /></a>
            <a href="#"><i className="fa fa-linkedin" /></a>
            <a href="#"><i className="fa fa-youtube" /></a>
          </div>
        </div>
      </div>

      {/* Main Menu */}
      <nav className="main-menu container">
        {/* Left Menu */}
        <ul className="menu-list left-menu">
         <li>
          <NavLink to="/" end className={({isActive}) => isActive ? "active" : ""}>
            Home
          </NavLink>
        </li>

        <li>
          <NavLink to="/about" className={({isActive}) => isActive ? "active" : ""}>
            About
          </NavLink>
        </li>

        <li>
          <NavLink to="/rooms" className={({isActive}) => isActive ? "active" : ""}>
            Rooms
          </NavLink>
        </li>

        <li>
          <NavLink to="/services" className={({isActive}) => isActive ? "active" : ""}>
            Services
          </NavLink>
        </li>
           
        </ul>

        {/* Center Logo */}
        <a href="/" className="center-logo">
          <img
            src="/img/plogo.svg"
            alt="Hotel Pahadi"
            className={`logo-img ${isScrolled ? "logo-small" : ""}`}
          />
        </a>

            {/* Right Menu */}
            <ul className="menu-list right-menu">
              <li>
          <NavLink to="/dinein" className={({isActive}) => isActive ? "active" : ""}>
            Dine In
          </NavLink>
        </li>

        <li>
          <NavLink to="/banquet" className={({isActive}) => isActive ? "active" : ""}>
            Banquet
          </NavLink>
        </li>

        <li>
          <NavLink to="/contact" className={({isActive}) => isActive ? "active" : ""}>
            Contact
          </NavLink>
        </li>

        <li>
          <NavLink to="https://wwwhotelpahadiconvention.bookingjini.in/" className="book-btn">
            Book Now
          </NavLink>
        </li>
        </ul>

        {/* Mobile Hamburger */}
        <button
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span></span><span></span><span></span>
        </button>
      </nav>

      {/* Mobile Slide Drawer */}
      <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
       
      <NavLink 
        to="/" 
        end
        className={({isActive}) => isActive ? "active" : ""}
        onClick={closeMenu}
      >
        Home
      </NavLink>

      <NavLink 
        to="/about" 
        className={({isActive}) => isActive ? "active" : ""}
        onClick={closeMenu}
      >
        About
      </NavLink>
       <NavLink 
        to="/rooms" 
        className={({isActive}) => isActive ? "active" : ""}
        onClick={closeMenu}
      >
        Rooms
      </NavLink>
        <NavLink 
        to="/services" 
        className={({isActive}) => isActive ? "active" : ""}
        onClick={closeMenu}
      >
        Services
      </NavLink>
        <NavLink 
        to="/dinein" 
        className={({isActive}) => isActive ? "active" : ""}
        onClick={closeMenu}
      >
        Dinein
      </NavLink>

        <NavLink 
        to="/banquet" 
        className={({isActive}) => isActive ? "active" : ""}
        onClick={closeMenu}
      >
        Banquet
      </NavLink>

      <NavLink 
        to="/gallery" 
        className={({isActive}) => isActive ? "active" : ""}
        onClick={closeMenu}
      >
        Gallery
      </NavLink>

      <NavLink 
        to="/contact" 
        className={({isActive}) => isActive ? "active" : ""}
        onClick={closeMenu}
      >
        Contact
      </NavLink>
      <NavLink 
        to="https://wwwhotelpahadiconvention.bookingjini.in/" 
        className="book-btn"
        onClick={closeMenu}
      >
        Book Now
      </NavLink>
      </div>

      {/* Overlay */}
      <div className={`overlay ${menuOpen ? "active" : ""}`} onClick={closeMenu}></div>

    </div>
  );
}

export default Navbar;
